module.exports = __webpack_public_path__ + "static/encryption-12aab81c75cc0105f3299be1b591a1c5.svg";